import { Menu } from "lucide-react";

import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTrigger,
} from "@/components/ui/sheet";

import { authSelector } from "@/store/auth/auth.slice";
import { useSelector } from "react-redux";
import { If } from "./condition";
import NavLink from "./nav-link";
import { useGlobalModal } from "../modals/modal-provider";
import { LoginModal } from "../modals/login-modal";
import { useState } from "react";
import { IconClose } from "../icons/IconClose";
import { accountSelector } from "@/store/account/account.slice";
import { PopoverInfoWallet } from "./PopoverInfoWallet";
import useHeader from "@/hooks/useHeader";
import { useAccount } from "wagmi";
import { BaseButton } from "../share/button";
import ConnectWalletModal from "../modals/connect-wallet";

const modalId = "connect-Wallet";

function MenuMoblie() {
  const { authLogin } = useSelector(authSelector);
  const { account } = useSelector(accountSelector);
  const { openModal, closeModal } = useGlobalModal();
  const { isConnected } = useAccount();
  const [open, setOpen] = useState(false);
  const { logout } = useHeader();

  const handleUpload = () => {
    setOpen(false);
    openModal({
      title: "Đăng nhập",
      description: "Nhập thông tin tài khoản của bạn bên dưới.",
      body: <LoginModal onSuccess={() => {}} />,
    });
  };

  const handleConnect = () => {
    setOpen(false);
    openModal({
      modalId: modalId,
      title: "Kết nối ví",
      body: (
        <ConnectWalletModal
          onCancel={() => {
            closeModal(modalId);
          }}
        />
      ),
    });
  };

  return (
    <div className="lg:hidden">
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetTrigger asChild>
          <button aria-label="Open menu" onClick={() => setOpen(true)}>
            <Menu size={28} />
          </button>
        </SheetTrigger>

        <SheetContent
          side="right"
          className="w-full sm:w-80 bg-gray-50 p-0 [&>button]:hidden"
        >
          <SheetHeader className="bg-white p-4">
            <div className="flex items-center justify-between">
              <If
                condition={!authLogin}
                Then={
                  <div
                    onClick={handleUpload}
                    className="flex items-center justify-center bg-white border-2 border-main text-sm font-bold text-main hover:bg-main hover:text-white h-9 px-4 rounded-md max-w-[120px]"
                  >
                    Đăng nhập
                  </div>
                }
                Else={
                  <div className="flex items-center gap-4">
                    <div className="flex justify-center items-center w-[30px] h-[30px] rounded-full bg-main  text-2xl text-white text-center  cursor-pointer">
                      {account?.name?.charAt(0)}
                    </div>
                    <div>
                      <p className="text-sm font-bold text-secondary_500 line-clamp-1">
                        {account?.name}
                      </p>
                      <div
                        onClick={() => {
                          logout();
                          setOpen(false);
                        }}
                        className="flex items-center gap-1"
                      >
                        <img src={"/icons/icon_logout.svg"} alt="" />
                        <span className="text-xs font-medium text-semantic_9">
                          Đăng xuất
                        </span>
                      </div>
                    </div>
                  </div>
                }
              />
              <div onClick={() => setOpen(false)}>
                <IconClose />
              </div>
            </div>
          </SheetHeader>
          <If
            condition={authLogin}
            Then={
              <If
                condition={isConnected}
                Then={
                  <SheetDescription className="bg-white p-4 mt-[10px]">
                    <PopoverInfoWallet />
                  </SheetDescription>
                }
                Else={
                  <SheetDescription className="bg-white p-4 mt-[10px]">
                    <BaseButton
                      outline
                      onClick={handleConnect}
                      className="w-full h-12"
                    >
                      Kết nối ví
                    </BaseButton>
                  </SheetDescription>
                }
              />
            }
          />
          <div className="h-full bg-white p-4 mt-[10px]">
            <div className=" grid grid-cols-1 gap-4">
              <SheetClose asChild>
                <NavLink
                  href="/"
                  className="flex items-center gap-2 p-4 text-main text-lg font-semibold"
                >
                  <img src={"/icons/icon_menu_1.svg"} alt="" />
                  Xác thực tài liệu
                </NavLink>
              </SheetClose>
              <SheetClose asChild>
                <NavLink
                  href="/upload"
                  className="flex items-center gap-2 p-4 text-main text-lg font-semibold"
                >
                  <img src={"/icons/icon_menu_upload.svg"} alt="" />
                  Phát hành tài liệu
                </NavLink>
              </SheetClose>
              <SheetClose asChild>
                <NavLink
                  href="/guide"
                  className="flex items-center gap-2 p-4 text-main text-lg font-semibold"
                >
                  <img src={"/icons/icon_menu_quizz.svg"} alt="" />
                  Hướng dẫn
                </NavLink>
              </SheetClose>
            </div>
          </div>
        </SheetContent>
      </Sheet>
    </div>
  );
}

export default MenuMoblie;
